<template>
    <v-card>
        <v-toolbar color="primary" dark flat>
            <v-icon left>person</v-icon>
            <v-toolbar-title v-text="student.first_name + ' ' + student.last_name"></v-toolbar-title>
            <v-spacer></v-spacer><v-btn icon @click="$emit('close')"><v-icon>close</v-icon></v-btn>
        </v-toolbar>
        <v-tabs v-model="tabs" fixed-tabs>
            <v-tab><v-icon :left="!$vuetify.breakpoint.xs">event</v-icon><span v-if="!$vuetify.breakpoint.xs">Events</span></v-tab>
            <v-tab><v-icon :left="!$vuetify.breakpoint.xs">school</v-icon><span v-if="!$vuetify.breakpoint.xs">Teacher</span></v-tab>
            <v-tab><v-icon :left="!$vuetify.breakpoint.xs">content_paste</v-icon><span v-if="!$vuetify.breakpoint.xs">Assignments</span><v-spacer v-if="false && !$vuetify.breakpoint.xs"></v-spacer></v-tab>
            <v-tab-item>
            <v-row class="ma-0 pa-0">
            <v-list two-line>
                <v-subheader v-if="(future_events + current_events).length == 0" no-gutters><i>No events</i></v-subheader>
                <v-subheader v-if="current_events && current_events.length > 0">Current</v-subheader>
                <v-list-item v-for="ev in current_events" :key="ev.start_date">
                        <v-list-item-avatar>
                            <v-btn fab :color="ev.creator.self ? 'primary' : 'secondary'">
                                <v-icon v-text="ev.type.icon"/>
                            </v-btn>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title v-text="ev.name"></v-list-item-title>
                            <v-list-item-subtitle><i>{{ Math.abs(Math.floor( (Date.parse(ev.end_date) - Date.now())  / (1e3 * 60 * 60 * 24) )) }}d left</i></v-list-item-subtitle>
                        </v-list-item-content>
                </v-list-item>
                <v-subheader v-if="future_events && future_events.length > 0">Upcoming</v-subheader>
                <v-list-item v-for="ev in future_events" :key="ev.start_date">
                        <v-list-item-avatar>
                            <v-btn fab :color="ev.creator.self ? 'primary' : 'secondary'">
                                <v-icon v-text="ev.type.icon"/>
                            </v-btn>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title v-text="ev.name"></v-list-item-title>
                            <v-list-item-subtitle><i>in {{ Math.abs(Math.floor( (Date.parse(ev.start_date) - Date.now())  / (1e3 * 60 * 60 * 24) )) }}d</i></v-list-item-subtitle>
                        </v-list-item-content>
                </v-list-item>
            </v-list>
            </v-row>
            </v-tab-item>
            <v-tab-item>
                <v-row class="ma-0 pa-0">
                    <v-list style="width: 100%">
                        <v-list-item>
                            <v-list-item-avatar>
                                <v-avatar color="primary" v-text="(student.teacher.first_name[0] + student.teacher.last_name[0]).toUpperCase()"/>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                    <v-list-item-title v-text="student.teacher.first_name + ' ' + student.teacher.last_name"/>
                                    <v-list-item-subtitle v-text="student.teacher.email" style="user-select: text !important"/>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-row>
            </v-tab-item>
            <v-tab-item>
                <v-row no-gutters>
                    <lesson-assignment-list :student_id="student.id" style="width: 100%"/>
                </v-row>
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>

import LessonAssignmentList from './LessonAssignmentList.vue'

export default {
    name: 'StudentDialog',
    components: {
        LessonAssignmentList
    },
    props: {
        mode: String,
        student_id: Number
    },
    data: function () {
        return {
            tabs: null,
        }
    },
    computed: {
        student () {
            return this.$store.getters['trainer/students'].find(s => s.id == this.student_id);
        },
        current_events: function () {
            return this.student.events.filter(e => (Date.parse(e.start_date) - Date.now() <= 0.) && (Date.parse(e.end_date) - Date.now() >= 0.))
        },
        future_events: function () {
            return this.student.events.filter(e => (Date.parse(e.start_date) - Date.now() >= 0.) && (Date.parse(e.end_date) - Date.now() >= 0.))
        }
    }
}

</script>
